import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button, Alert, Badge } from 'react-bootstrap';
import { 
    deleteSparepartImport, 
    setDeleteSparepartImportId 
} from '../../../actions/sparepartImports';
import moment from 'moment';

const SparepartImportDeleteForm = () => {
    const dispatch = useDispatch();
    
    const { 
        deleteItemId, 
        loading, 
        error,
        sparepartImports,
        currentPage
    } = useSelector(state => state.sparepartImport);

    // Find the import to delete
    const importToDelete = sparepartImports?.find(importItem => importItem.id === deleteItemId);

    const handleClose = () => {
        dispatch(setDeleteSparepartImportId(null));
    };

    const handleDelete = async () => {
        const success = await dispatch(deleteSparepartImport(deleteItemId, currentPage));
        if (success) {
            handleClose();
        }
    };

    const formatNumber = (value) => {
        if (value === null || value === undefined) return '0';
        
        // Handle both string and number inputs
        let numValue = value;
        if (typeof value === 'string') {
            // Remove existing commas and convert to number
            numValue = parseFloat(value.replace(/,/g, ''));
        }
        
        if (isNaN(numValue)) return '0';
        return numValue.toLocaleString('en-US');
    };

    const formatQuantity = (quantity) => {
        if (quantity === null || quantity === undefined) return '0';
        
        let numValue = quantity;
        if (typeof quantity === 'string') {
            numValue = parseFloat(quantity.replace(/,/g, ''));
        }
        
        if (isNaN(numValue)) return '0';
        
        // Format to up to 5 decimal places, removing trailing zeros
        return parseFloat(numValue.toFixed(5)).toString();
    };

    return (
        <Modal show={!!deleteItemId} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title className="text-danger">Importni O'chirish</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {error && (
                    <Alert variant="danger">
                        {error.message || 'Xatolik yuz berdi'}
                    </Alert>
                )}

                {importToDelete && (
                    <div>
                        <p className="mb-3">
                            Quyidagi ehtiyot qism importini o'chirishni tasdiqlaysizmi?
                        </p>
                        
                        <div className="border rounded p-3 bg-light">
                            <div className="row">
                                <div className="col-sm-4">
                                    <strong>Import raqami:</strong>
                                </div>
                                <div className="col-sm-8">
                                    #{importToDelete.reference_number || importToDelete.id}
                                </div>
                            </div>
                            
                            <div className="row mt-2">
                                <div className="col-sm-4">
                                    <strong>Ombor:</strong>
                                </div>
                                <div className="col-sm-8">
                                    {importToDelete.warehouse?.name}
                                </div>
                            </div>
                            
                            <div className="row mt-2">
                                <div className="col-sm-4">
                                    <strong>Ta'minotchi:</strong>
                                </div>
                                <div className="col-sm-8">
                                    {importToDelete.supplier?.name || "---"}
                                </div>
                            </div>
                            
                            <div className="row mt-2">
                                <div className="col-sm-4">
                                    <strong>Import turi:</strong>
                                </div>
                                <div className="col-sm-8">
                                    {importToDelete.is_bulk_import ? (
                                        <Badge bg="info">
                                            {importToDelete.items?.length || 0} ta element
                                        </Badge>
                                    ) : (
                                        <Badge bg="secondary">Yakka import</Badge>
                                    )}
                                </div>
                            </div>
                            
                            {importToDelete.is_bulk_import ? (
                                <div className="row mt-2">
                                    <div className="col-sm-4">
                                        <strong>Elementlar:</strong>
                                    </div>
                                    <div className="col-sm-8">
                                        {importToDelete.items?.slice(0, 3).map((item, index) => (
                                            <div key={index} className="small">
                                                • {item.spare_part?.name} - {formatQuantity(item.quantity)} {item.spare_part?.unit?.name}
                                            </div>
                                        ))}
                                        {importToDelete.items?.length > 3 && (
                                            <div className="small text-muted">
                                                va yana {importToDelete.items.length - 3} ta element...
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="row mt-2">
                                    <div className="col-sm-4">
                                        <strong>Ehtiyot qism:</strong>
                                    </div>
                                    <div className="col-sm-8">
                                        {importToDelete.sparepart?.name}
                                    </div>
                                </div>
                            )}
                            
                            <div className="row mt-2">
                                <div className="col-sm-4">
                                    <strong>Jami summa:</strong>
                                </div>
                                <div className="col-sm-8">
                                    <strong>{formatNumber(importToDelete.total_amount)} so'm</strong>
                                </div>
                            </div>
                            
                            <div className="row mt-2">
                                <div className="col-sm-4">
                                    <strong>Sana:</strong>
                                </div>
                                <div className="col-sm-8">
                                    {moment(importToDelete.date).format('DD-MM-YYYY')}
                                </div>
                            </div>

                            {importToDelete.description && (
                                <div className="row mt-2">
                                    <div className="col-sm-4">
                                        <strong>Izoh:</strong>
                                    </div>
                                    <div className="col-sm-8">
                                        {importToDelete.description}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="alert alert-warning mt-3 mb-0">
                            <small>
                                <strong>Diqqat:</strong> Bu amal qaytarib bo'lmaydi. Import ma'lumotlari butunlay o'chiriladi va ehtiyot qismlar ombordan chiqariladi.
                            </small>
                        </div>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Bekor qilish
                </Button>
                <Button 
                    variant="danger" 
                    onClick={handleDelete}
                    disabled={loading}
                >
                    {loading ? 'O\'chirilmoqda...' : 'Ha, o\'chirish'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SparepartImportDeleteForm; 